<template>
  <el-carousel
    :class="{
      'dots-space-1': spaceBottom === true,
      'dots-space-n1': spaceBottom === 'negative',
    }"
    class="wrapper-carousel-dots"
    :autoplay="true"
    :interval="5000"
    :height="height"
    trigger="click"
    :arrow="arrows"
  >
    <slot />
  </el-carousel>
</template>

<script>
  export default {
    props: {
      height: {
        default: "",
        type: String,
        required: false,
      },
      spaceBottom: {
        type: [String, Boolean],
        default: false,
        required: false,
      },
      arrows: {
        type: String,
        default: "never",
        required: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/_variables.scss";
  .wrapper-carousel-dots {
    // overflow-x: clip;
    // overflow-y: visible;

    &.dots-space-1 {
      :deep(.el-carousel__indicators.el-carousel__indicators--horizontal) {
        bottom: 4rem;

        @media (min-width: 992px) {
          bottom: 5rem;
        }
      }
    }

    &.dots-space-n1 {
      :deep(.el-carousel__indicators.el-carousel__indicators--horizontal) {
        bottom: -1.5rem;

        @media (min-width: 991px) {
          bottom: 0rem;
        }

        @media (max-width: 768px) {
          bottom: 0rem;
        }
      }
    }
  }

  :deep(.el-carousel__arrow) {
    @media (max-width: 991.97px) {
      display: none;
    }
    &,
    &:hover,
    &:active {
      background: none;
    }

    & i {
      font-size: 55px;
    }
  }

  :deep(.el-carousel__indicators.el-carousel__indicators--horizontal) {
    bottom: 2rem;

    .el-carousel__button {
      width: 29.5px;
      height: 4px;
      border-radius: 8px;
      background-color: #c4c4c4;
      margin: 0.2rem 0.5rem 0.2rem 0.5rem;

      @media (min-width: 992px) {
        margin: 0.2rem;
      }
    }

    .is-active * {
      background: $primary;
      border-radius: 8px;
    }
  }
</style>
